import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RiShieldLine, RiArrowLeftLine, RiDashboardLine } from 'react-icons/ri';
import { useAuth } from '../contexts/AuthContext';
import { formatRoleName } from '../utils/roles';
import { useTheme } from '../contexts/ThemeContext';

const Unauthorized = () => {
  const { user } = useAuth();
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-center items-center py-16 px-4">
      <div className={`p-8 rounded-xl shadow-2xl max-w-md w-full text-center ${isDarkMode ? 'bg-zinc-900 border border-zinc-800' : 'bg-white'}`}>
        <div className="inline-flex justify-center items-center w-20 h-20 bg-red-100 rounded-full mb-6">
          <RiShieldLine className="text-4xl text-red-600" />
        </div>

        <h1 className={`text-2xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
          Access Denied
        </h1>

        <p className={`mb-2 ${isDarkMode ? 'text-zinc-400' : 'text-gray-500'}`}>
          You don't have permission to view this page.
        </p>

        {user?.role && (
          <p className={`text-sm mb-8 ${isDarkMode ? 'text-zinc-500' : 'text-gray-400'}`}>
            Your current role is{' '}
            <span className={`font-semibold px-2 py-0.5 rounded ${isDarkMode ? 'bg-zinc-800 text-zinc-200' : 'bg-gray-100 text-gray-700'}`}>
              {formatRoleName(user.role)}
            </span>
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className={`flex items-center justify-center gap-2 px-4 py-2 rounded-lg border font-medium transition-colors ${
              isDarkMode
                ? 'border-zinc-700 text-zinc-300 hover:bg-zinc-800'
                : 'border-gray-300 text-gray-700 hover:bg-gray-100'
            }`}
          >
            <RiArrowLeftLine size={18} />
            Go Back
          </button>

          <button
            onClick={() => navigate('/admin/dashboard')}
            className="flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white font-medium transition-colors"
          >
            <RiDashboardLine size={18} />
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
